var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_14071_15322)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "url(#paint0_linear_14071_15322)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "url(#paint1_linear_14071_15322)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.42969C3.48 1.42969 1.42969 3.48 1.42969 6C1.42969 8.52 3.48 10.5703 6 10.5703C8.52 10.5703 10.5703 8.52 10.5703 6C10.5703 3.48 8.51998 1.42969 6 1.42969ZM8.80563 7.2267C8.87018 7.33554 8.87156 7.47045 8.80905 7.58032C8.74657 7.68984 8.62985 7.75781 8.5035 7.75781H7.03477L6.30211 8.99205C6.23895 9.09884 6.12429 9.16406 6 9.16406C5.87571 9.16406 5.76105 9.09884 5.69787 8.99205L4.96523 7.75781H3.4965C3.37015 7.75781 3.25343 7.68984 3.19095 7.58032C3.12846 7.47045 3.12984 7.33554 3.19437 7.2267L3.9229 5.99932L3.19437 4.7733C3.12982 4.66446 3.12844 4.52955 3.19095 4.42003C3.25343 4.31016 3.37015 4.24219 3.4965 4.24219H4.96523L5.69789 3.00795C5.82424 2.79441 6.1758 2.79441 6.30213 3.00795L7.03477 4.24219H8.5035C8.62985 4.24219 8.74657 4.31016 8.80905 4.42003C8.87154 4.52955 8.87016 4.66448 8.80563 4.7733L8.0771 5.99932L8.80563 7.2267Z",
    fill: "url(#paint2_linear_14071_15322)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_14071_15322",
    x: -5.38494,
    y: -5.38494,
    width: 22.7699,
    height: 22.7699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.38494,
    dy: 5.38494
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14071_15322"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.38494,
    dy: -5.38494
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_14071_15322",
    result: "effect2_innerShadow_14071_15322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14071_15322",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20D252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14071_15322",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14071_15322",
    x1: 6,
    y1: 10.5703,
    x2: 6,
    y2: 1.42969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.45bf21b9dd76e6d123cfac25793a19ec.svg";
export { ForwardRef as ReactComponent };